export default "__VITE_ASSET__11af8b22__"